export default (data) => `
	<p>Keine Termine</p>
`;
